import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgAssigned = (props: SvgProps) => (
  <Svg fill="none" height={24} width={25} {...props}>
    <Path
      clipRule="evenodd"
      d="M14.361 3.597a9 9 0 0 0-10.26 14.016c1.086-1.447 2.556-2.553 4.245-3.141a8.5 8.5 0 0 1 2.79-.472h.004a8.5 8.5 0 0 1 2.79.473c1.688.588 3.157 1.694 4.242 3.14a9 9 0 0 0 1.863-6.961 1 1 0 0 1 1.978-.3 11 11 0 0 1-10.888 12.649 10.97 10.97 0 0 1-8.103-3.561l.004-.01a11 11 0 0 1 12.052-17.7 1 1 0 1 1-.717 1.867M9 20.743a9 9 0 0 0 4.932-.188 9 9 0 0 0 2.804-1.516C15.435 17.165 13.381 16 11.136 16s-4.303 1.167-5.602 3.044A9 9 0 0 0 9 20.742"
      fill={props.color}
      fillRule="evenodd"
    />
    <Path
      clipRule="evenodd"
      d="M8.717 12.282c.64.58 1.488.933 2.42.934h.002c.932 0 1.782-.353 2.422-.933a3.608 3.608 0 1 0-4.844-.001m2.422-1.066a1.608 1.608 0 1 0 0-3.216 1.608 1.608 0 0 0 0 3.216"
      fill={props.color}
      fillRule="evenodd"
    />
    <Path
      d="M18.569 4.026a1 1 0 1 0-1.415 1.414l1.883 1.883a1 1 0 0 0 1.414 0l3.394-3.394a1 1 0 0 0-1.414-1.414L19.744 5.2z"
      fill={props.color}
    />
  </Svg>
);
const Memo = memo(SvgAssigned);
export default Memo;
